import Vue from 'vue'
import VueGallery from 'vue-gallery'
import Navigation from '../components/partials/Navigation/Navigation.vue'
import About from '../components/partials/About/About.vue'
import Media from '../components/partials/Media/Media.vue'
import Contact from '../components/partials/Contact/Contact.vue'
import Footer from '../components/partials/Footer/Footer.vue'
import Imprint from '../components/partials/Imprint/Imprint.vue'

export function addComponents () {
  Vue.component('gallery', VueGallery)
  Vue.component('navigation', Navigation)
  Vue.component('about', About)
  Vue.component('media', Media)
  Vue.component('contact', Contact)
  Vue.component('vfooter', Footer)
  Vue.component('imprint', Imprint)
}



// WEBPACK FOOTER //
// ./src/config/components.js